import HorizontalSlider from './HorizontalSlider';

export default HorizontalSlider;
